import { render, staticRenderFns } from "./TopContact.vue?vue&type=template&id=294c2ccf&scoped=true"
import script from "./TopContact.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopContact.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TopContact.vue?vue&type=style&index=0&id=294c2ccf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294c2ccf",
  null
  
)

export default component.exports